export default __webpack_public_path__ + "static/media/starFilled_large.5574f0e8.svg";